var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BoxWrap",
        { attrs: { title: _vm.$t("sfe.reportModule.carpacTab1") } },
        [
          _c("carpac-table", {
            attrs: {
              tab: "carpacTab1",
              "region-options": _vm.regionOptions,
              "rim-list": _vm.rimList,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BoxWrap",
        { attrs: { title: _vm.$t("sfe.reportModule.carpacTab2") } },
        [
          _c("carpac-table", {
            attrs: {
              tab: "carpacTab2",
              "region-options": _vm.regionOptions,
              "rim-list": _vm.rimList,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BoxWrap",
        { attrs: { title: _vm.$t("sfe.reportModule.carpacTab3") } },
        [
          _c("carpac-table", {
            attrs: {
              tab: "carpacTab3",
              "region-options": _vm.regionOptions,
              "rim-list": _vm.rimList,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }